import * as React from "react";
import { Button, Checkbox, Input, message } from "antd";
import styled from "styled-components";
import { useAuth } from "@/component/Auth";
import { conferencePerson } from "@/api/conference";

const Container = styled.div`
  padding: 60px 60px 0 20px;
  .item {
    padding: 10px 0;
  }
`;

const MeetingSetting: React.FunctionComponent = () => {
  const auth = useAuth();
  const { loginfo } = auth;

  const [passwordEnable, setPasswordEnable] = React.useState(
    !!loginfo.passwordEnable
  );
  const [password, setPassword] = React.useState(loginfo.password);

  const [ownerPasswordEnable, setOwnerPasswordEnable] = React.useState(
    !!loginfo.ownerPasswordEnable
  );
  const [ownerPassword, setOwnerPassword] = React.useState(
    loginfo.ownerPassword
  );

  const [allowEarlyEntry, setAllowEarlyEntry] = React.useState(
    !!loginfo.allowEarlyEntry
  );
  const [muteJoinMeeting, setMuteJoinMeeting] = React.useState(
    !!loginfo.muteJoinMeeting
  );

  const { conferenceNo } = loginfo;
  const saveSetting = async () => {
    await conferencePerson({
      passwordEnable: passwordEnable ? 1 : 0,
      password,
      ownerPasswordEnable: ownerPasswordEnable ? 1 : 0,
      ownerPassword,
      allowEarlyEntry: allowEarlyEntry ? 1 : 0,
      muteJoinMeeting: muteJoinMeeting ? 1 : 0,
      conferenceNo,
    });
    message.success("保存成功!");
  };

  return (
    <Container className="f1">
      <div className="jssb mb20">
        <span>个人会议号</span>
        <span>{loginfo.conferenceNo}</span>
      </div>
      <div className="item">
        <Checkbox
          checked={passwordEnable}
          onChange={(t) => setPasswordEnable(t.target.checked)}
        >
          入会密码
        </Checkbox>
      </div>
      {passwordEnable && (
        <div className="item">
          <Input
            value={password}
            onChange={(e) => setPassword(e.target.value)}
          />
        </div>
      )}

      <div className="item">
        <Checkbox
          checked={ownerPasswordEnable}
          onChange={(t) => setOwnerPasswordEnable(t.target.checked)}
        >
          主持人密码
        </Checkbox>
      </div>
      {ownerPasswordEnable && (
        <div className="item">
          <Input
            value={ownerPassword}
            onChange={(e) => setOwnerPassword(e.target.value)}
          />
        </div>
      )}

      {/* <div className="item">
        <Checkbox
          checked={allowEarlyEntry}
          onChange={(t) => setAllowEarlyEntry(t.target.checked)}
        >
          允许成员在主持人入会前加入会议
        </Checkbox>
      </div> */}

      <div className="item">
        <Checkbox
          checked={muteJoinMeeting}
          onChange={(t) => setMuteJoinMeeting(t.target.checked)}
        >
          成员入会时自动静音
        </Checkbox>
      </div>
      <div className="item jsc mt20">
        <Button type="primary" onClick={saveSetting}>
          保存
        </Button>
      </div>
    </Container>
  );
};

export default MeetingSetting;
